import { Pagination, Trans } from '@/components'

export const BOOT_SOURCE_PAGE_SIZE = 8

interface BootSourcePaginationProps {
  current: number
  selected: number
  total: number
  onChange: (page: number) => void
  serverPaginated?: boolean
}

export function BootSourcePagination({
  current,
  selected,
  total,
  onChange,
  serverPaginated = false,
}: BootSourcePaginationProps) {
  return (
    <div
      className="mt-4 flex items-center justify-between gap-4"
      data-ai-component="boot-source-pagination"
    >
      <p className="t-sm text-tertiary" aria-live="polite">
        {serverPaginated ? (
          <Trans
            i18nKey="create.imageView.selectedPageCount"
            values={{ selected, current, pages: Math.ceil(total / BOOT_SOURCE_PAGE_SIZE) }}
          >
            Selected {'{{selected}}'} · Page {'{{current}}'} of {'{{pages}}'}
          </Trans>
        ) : (
          <Trans i18nKey="create.selectedItemsCount" values={{ selected, total }}>
            Selected {'{{selected}}'} of {'{{total}}'} items
          </Trans>
        )}
      </p>
      <Pagination
        size={BOOT_SOURCE_PAGE_SIZE}
        total={total}
        current={current}
        className="shrink-0"
        onChange={onChange}
      />
    </div>
  )
}
